import React from 'react';
import OrganizationDetailsPage from '../components/OrganizationDetailsPage';

const OrganizationDetailsApp = (props) => (
  <OrganizationDetailsPage {...props} />
);

export default OrganizationDetailsApp;
